<template>
  
  <header>
      <nav class="" id="vy_header ">
        <h1 v-on:click="home" style="cursor:pointer"  class="p-4"  ><img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" /></h1>
      </nav>
      <div style="text-align: left;">
          <table class="vy-search-form-table-nav">
          <!-- 日程 -->
          <tr>
              <th style="width: 160px;display: flex;align-items: center;justify-content: space-between;padding-right: 2px;">
                <label for="kaisai_date">日程</label> <input v-on:click="today()" type="button" value="今日"/>
              </th>
              <td style="text-align: left;margin-bottom:10px">
                <div class="container" style="padding:0">
                    <div class="col-md-auto m-0 p-0" style="
                    display: flex;
                    align-items: center;">
                    <input type="date" class="form-control" style="margin-right:10px;width:150px"
                      id="start_date" name="start_date"
                      max="9999-12-31" 
                      v-on:change="Check()" 
                      v-model="start_date0"> ～</div>
                    <div class="col-md-auto m-0 p-0">
                      <input type="date" class="form-control" style="margin-right:10px;width:150px"
                        id="end_date" name="end_date"
                        max="9999-12-31" 
                        v-on:change="Check()" 
                        v-model="end_date0"></div>
                      
                </div>
              </td>
          </tr>

        </table>
      </div>
    </header>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
  import { useRouter,useRoute } from 'vue-router'

const props = defineProps(['param']);
const router = useRouter();
let route = useRoute()
const cityname = route.params.shakyo // 市区町村コード
//------------------------------ リンク --------------------------------
const home = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push("/"+route.params.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
}

const Shakyo_data = ref(props.param.Shakyo_data) // 社協設定データ

let start_date0 = ref(props.param.start_date) // 日時（自）
let end_date0 = ref(props.param.end_date) // 日時（至）



/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])
    
let Check = function(){  //検索を開始する

    //  検索開始の合図とともに検索条件を送信する
    emit('call',{cmd:'checkin_search',
                start_date0:start_date0.value,
                end_date0:end_date0.value,
                id:route.params.id
                });
}

// 日時（自・至）に今日の日付を入力する
let today = function(){
  
  const today = new Date()
  let set_date = new Date(today);
  set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
  set_date = new Date(set_date);
  let today_date = set_date.getFullYear()+"-"+("000"+(set_date.getMonth()+1)).slice(-2)+"-"+("000"+set_date.getDate()).slice(-2)

  start_date0.value = today_date
  end_date0.value = today_date

  Check()
}

</script>

<style scoped>
.radio_button{
  margin-bottom:10px
}
</style>